import { render, staticRenderFns } from "./MonthDisplay.vue?vue&type=template&id=15915c12&scoped=true"
import script from "./MonthDisplay.vue?vue&type=script&lang=js"
export * from "./MonthDisplay.vue?vue&type=script&lang=js"
import style0 from "./MonthDisplay.vue?vue&type=style&index=0&id=15915c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15915c12",
  null
  
)

export default component.exports